import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "skip",
  "use": "skip-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"skip\"><path d=\"M15.91 5.36L10.248 0v2.792C4.384 3.799.098 9.362.098 15.619c0 .2.258.254.321.063 2.842-8.647 9.829-7.64 9.829-7.64v2.792l5.662-5.473z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id